import { createContext } from 'react';

import type { GaugeChartThresholdProps } from '../slots/Threshold.js';

export const GaugeChartThresholdContext = createContext<
  GaugeChartThresholdProps[]
>([]);
